//Third Party
import React from 'react';
import Link from 'next/link';

// Utils
import { ListingBySlugPartial } from '@utils/imperative-node-queries';
import { concatenateAndReplace } from '@utils/test-helpers';

// UI
import { Typography } from '@components/typography';

type Props = { listing: ListingBySlugPartial };

export const HeadingAndTitleBar: React.FC<Props> = ({ listing }) => {
  return (
    <div className="text-primary-main">
      <div className="flex items-center space-x-2 sm:justify-between sm:space-x-0">
        <Typography
          component="h1"
          variant="title3"
          variantM="title3"
          variantL="title2"
          className="overflow-hidden text-ellipsis"
          data-testid={concatenateAndReplace(`${listing.name}`)}
        >
          {listing.name}
        </Typography>
      </div>

      <div className="mt-2 flex items-center space-x-2 sm:mt-0 md:hidden">
        {/* Place */}
        <div className="flex md:hidden">
          <Link href="#map" scroll={false}>
            <Typography
              variant="small"
              component="p"
              className="border-b border-primary-light font-semibold text-primary-light"
            >
              {listing.city}, {listing.stateOrProvinceLongName}
            </Typography>
          </Link>
        </div>
      </div>

      <div className="hidden items-center justify-between md:flex">
        <div className="text-sm text-primary-light underline">
          {listing.city && listing.stateOrProvinceLongName
            ? `${listing.city}, ${listing.stateOrProvinceLongName}`
            : ' '}
        </div>
      </div>
    </div>
  );
};
